import { render, staticRenderFns } from "./homeCard.vue?vue&type=template&id=ea09f5e2&scoped=true&"
import script from "./homeCard.vue?vue&type=script&lang=js&"
export * from "./homeCard.vue?vue&type=script&lang=js&"
import style0 from "./homeCard.vue?vue&type=style&index=0&id=ea09f5e2&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ea09f5e2",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!/home/runner/work/kolobox-admin/kolobox-admin/node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib'
import { VCardTitle } from 'vuetify/lib'
installComponents(component, {VCard,VCardTitle})
